"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHexColor = void 0;
const assertString_1 = require("./util/assertString");
const hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
function isHexColor(str) {
    (0, assertString_1.assertString)(str);
    return hexcolor.test(str);
}
exports.isHexColor = isHexColor;
